import React from 'react';
import PropTypes from 'prop-types';

function MapLegend(props) {
  return (
    <div className={`c-legend-map ${props.parentClass}`}>
      <span className="legend-value-definition">{`${props.titleYear || ' '} RGI Score`}</span>
      <ul className="legend-list">
        {props.data.map((item, index) => (
          <li key={index} style={item.style} className="legend-item">
            <div className={`tier-color ${item.colorCode}`}></div>
            <span className="tier-value">{item.value}</span>
            <span className="tier-description">{item.description}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

MapLegend.defaultProps = {
  data: []
};

MapLegend.propTypes = {
  data: PropTypes.array,
  titleYear: PropTypes.number,
  parentClass: PropTypes.string
};

export default MapLegend;



// WEBPACK FOOTER //
// ./app/components/country-profiles/MapLegend.jsx